module.exports = __webpack_public_path__ + "img/max-file-subtract--pdf.22a76066.svg";